import { createSelector } from 'reselect';

const selectForm = (state) => {
  return state.form;
};

export const selectInvalidFormFields = createSelector(
  [selectForm],
  (form) => {
    return form.invalidFormFields;
  }
);

export const selectDependentIgnoreList = createSelector(
  [selectForm],
  (form) => {
    return form.dependentIgnoreList;
  }
);

export const selectPreventFormSubmissionList = createSelector(
  [selectForm],
  (form) => {
    return form.preventFormSubmissionList;
  }
);